export enum Lottery {
    /** Lottery */
    sportka = "sportka",
    /** Lottery */
    sportkaMh = "sportkamh",
    /** Lottery */
    eurojackpot = "eurojackpot",
    /** Lottery */
    euromiliony = "euromiliony",
    /** Lottery */
    stastnych10 = "stastnych-10",
    /** Lottery */
    kasicka = "kasicka",
    /** Lottery */
    extraRenta = "extra-renta",
    /** Lottery */
    extraRentaMh = "extrarentamh",
    /** Lottery */
    stastneDatum = "stastne-datum",
    /** Lottery */
    sazkaMobil = "sazka-mobil",
    /** Lottery */
    totoSazka = "toto-sazka",
    /** Quick lottery */
    rychleKacky = "rychle-kacky",
    /** Quick lottery */
    kameny = "kameny",
    /** Quick lottery */
    keno = "keno",
    /** Quick lottery */
    rychla6 = "rychla-6",
    /** Quick lottery */
    vsechnoNeboNic = "vsechno-nebo-nic",
    /** Quick lottery */
    miniRenta = "mini-renta",
    /** Quick lottery */
    powerSpin = "power-spin",
    /** Lottery */
    sance = "sance",
    /** Lottery */
    sanceMh = "sancemh",
    /** Lottery */
    extra6 = "extra6",
    /** Lottery */
    euroSance = "eurosance",
    /** Lottery */
    sanceMilion = "sancemilion",

    /** Used on KASA */
    all = "all",
    ticket = "los",
}
